import { Scale } from 'lucide-react'

type ChatContentHeaderProps = {
  title: string
  subtitle: string
  isIntro: boolean
}

export function ChatContentHeader({ title, subtitle, isIntro }: ChatContentHeaderProps) {
  if (isIntro) {
    return (
      <div className="flex items-center" style={{ gap: '10px' }}>
        <div className="rounded-xl glass-icon flex items-center justify-center" style={{ width: '36px', height: '36px' }}>
          <Scale size={18} className="text-telegram-button" />
        </div>
        <div>
          <h1 className="font-bold" style={{ fontSize: '14px' }}>{title}</h1>
          <p style={{ fontSize: '10px', color: 'var(--header-hint-color)' }}>{subtitle}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="glass-surface" style={{ padding: '10px 12px' }}>
      <h1 className="font-semibold truncate" style={{ fontSize: '13px' }}>{title}</h1>
      <p className="truncate" style={{ fontSize: '10px', color: 'var(--header-hint-color)', marginTop: '2px' }}>
        {subtitle}
      </p>
    </div>
  )
}
